import Industries from '../dynamics/industries'
export const getIndustryById = (industryId) => Industries.find(({ id }) => id === industryId)